// extracted by mini-css-extract-plugin
export default {"tp":"CustomSlider_tp__tgRW8"};